import React, {Component} from 'react';
import {connect} from 'react-redux';
import Carousel from '@homeaway/react-carousel';
import MarkerMap from '../../common/maps/MarkerMap';
import {FormattedMessage, injectIntl} from 'react-intl';
import Card from '../great-place-card/Card';
import {highlightInMap, clearMapHighlight, clearCarouselFocus} from '../../../actions/greatPlaces';
import {SeeMorePropertiesConnected} from './SeeMorePropertiesCard';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';
import {formatCurrency} from '../../../utils/formatters';
import {SegmentFilters} from './SegmentFilters';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

function onMouseOverCard(dispatch, id) {
    return () => {
        dispatch(highlightInMap(id));
        dispatch(clearCarouselFocus());
    };
}

function onMouseOutCard(dispatch) {
    return () => {
        dispatch(clearMapHighlight());
    };
}

export function sendToEdap(tripleId, eventrefinements) {
    const delayProcessing = {delayProcessing: true};
    const mainData = {
        actionlocation: 'properties-module',
        listingid: tripleId,
        eventrefinements
    };
    return () => pushEdapEvent('property.tile.click', mainData, delayProcessing);
}

function listingAsPropertyCard(dispatch, types, highlightedId) {
    return (listing) => (
        <Card
            onClick={sendToEdap(listing.tripleId, types)}
            key={listing.id}
            highlighted={listing.id === highlightedId}
            propertyName={listing.propertyName}
            price={listing.price}
            review={listing.review}
            imageSrc={listing.thumbnailUrl}
            sleeps={listing.sleeps}
            bedrooms={listing.bedrooms}
            bathrooms={listing.bathrooms}
            link={`//${listing.listingUri}`}
            onMouseOver={onMouseOverCard(dispatch, listing.id)}
            onMouseOut={onMouseOutCard(dispatch)}
        />
    );
}

function validLocation({geoCode}) {
    return geoCode.addressLatLngIsValid;
}

function convertListingToMarker(numberFormatter, listing) {
    const id = `${listing.id}-${listing.unitUuid}`;

    const position = {
        lat: listing.geoCode.latitude,
        lng: listing.geoCode.longitude
    };

    const showExactLocation = listing.geoCode.showExactLocation;
    const key = listing.id;
    const label = formatCurrency(numberFormatter, listing.price.value, listing.price.currency);

    return {
        id,
        position,
        showExactLocation,
        key,
        label
    };
}

export class GreatPlacesToStayComponent extends Component {
    render() {
        const {
            intl: {formatMessage, formatNumber},
            dispatch,
            listings = [],
            highlightedId,
            carouselFocus,
            destinationName,
            propertyType,
            isMobile
        } = this.props;

        if (listings.length === 0) {
            return null;
        }

        const markers = listings
            .filter(validLocation)
            .map((listing) => convertListingToMarker(formatNumber, listing));

        const types = getRefinements(propertyType);

        const focusedCardId = highlightedId || carouselFocus;
        const propertyCards = listings
            .slice(0, 6)
            .map(listingAsPropertyCard(dispatch, types, focusedCardId));

        propertyCards.push(
            <SeeMorePropertiesConnected
                key={-1}
                imageSrc={listings[0].thumbnailUrl}
            />
        );

        const listingsIdIndex = listings
            .map((listing) => listing.id)
            .indexOf(carouselFocus);

        const focusedIndex = listingsIdIndex === -1
            ? null
            : listingsIdIndex;

        const title = (
            <h2 className="great-places-to-stay__title">
                <FormattedMessage
                    id={'module.placestostay.title'}
                    values={{
                        destinationName,
                        propertyTypeSingularNoArticle: formatMessage({
                            id: `${propertyType}_singular_no_article`,
                            defaultMessage: 'place'
                        })
                    }}
                />
            </h2>
        );

        const map = isMobile ? null : (
            <div className="great-places-to-stay__map">
                <MarkerMap
                    channel="homeaway-slp"
                    clickableMarker
                    highlightedId={highlightedId}
                    dispatch={dispatch}
                    markers={markers}
                    listings={listings}
                />
            </div>
        );

        const carousel = (
            <Carousel
                className="great-places-to-stay__carousel"
                focusIndex={focusedIndex}
                pageSize={3}
            >
                {propertyCards}
            </Carousel>
        );

        return (
            <div className="container great-places-to-stay">
                {title}
                <SegmentFilters />
                {map}
                {carousel}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        listings: state.destination.listings,
        carouselFocus: state.greatPlaces.carouselFocus,
        highlightedId: state.greatPlaces.highlightedId,
        destinationName: state.destination.details.simpleName,
        propertyType: state.destination.propertyType,
        isMobile: state.config.isMobile
    };
}

export const GreatPlacesToStay = injectIntl(
    connect(mapStateToProps)(determineIfMobile(GreatPlacesToStayComponent))
);
